<!-- Young -->
<template>
  <div class="version-ec">
    <public-bread-crumb :routes="routes"></public-bread-crumb>
    <a-spin tip="Loading..." :spinning="btnLoading">
      <div class="content-wrap">
        <p class="page-title">{{ "版本上传" }}</p>
        <div class="from-wrap">
          <a-spin :spinning="formLoading">
            <a-form style="width: 100%" :form="formData">
              <a-row>
                <a-col :span="12">
                  <a-form-item
                    label="设备类型"
                    required
                    :labelCol="{ span: 8 }"
                    :wrapperCol="{ span: 11 }"
                  >
                    <a-select
                      @change="checkasstype"
                      :disabled="noUpLoad"
                      placeholder="请选择设备类型"
                      class="item-input"
                      v-decorator="[
                        'type',
                        {
                          validateTrigger: 'blur',
                          rules: [{ required: true, message: '请选择设备类型' }]
                        }
                      ]"
                    >
                      <a-select-option
                        v-for="(i, index) in deviceTypeSelects"
                        :key="index"
                        :value="i.name"
                        >{{ i.name }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item
                    label="设备型号"
                    required
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 11 }"
                  >
                    <a-select
                      mode="multiple"
                      :allowClear="true"
                      :showArrow="true"
                      :disabled="nocheckmodel"
                      placeholder="请选择设备型号"
                      class="item-input"
                      v-decorator="[
                        'deviceModel',
                        {
                          validateTrigger: 'blur',
                          rules: [{ required: true, message: '请选择设备型号' }]
                        }
                      ]"
                    >
                      <template #removeIcon>
                        <a-icon type="close-circle" />
                      </template>
                      <a-select-option
                        v-for="(i, index) in deviceModelSelects"
                        :key="index"
                        :value="i.name"
                        >{{ i.name }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :labelCol="{ span: 4, offset: 1 }">
                  <a-form-item
                    label=""
                    required
                    :wrapperCol="{ span: 16, offset: 4 }"
                    :labelCol="{ span: 4 }"
                  >
                    <a-upload-dragger
                      :customRequest="() => {}"
                      name="file"
                      action=""
                      :fileList="fileList"
                      @change="handleChange"
                      v-decorator="[
                        'file',
                        {
                          validateTrigger: 'change',
                          rules: [{ validator: checkFile }]
                        }
                      ]"
                    >
                      <div>
                        <p class="ant-upload-drag-icon">
                          <a-icon type="upload" style="color: #ACAFB4;" />
                        </p>
                        <p class="ant-upload-text">
                          点击添加或者拖拽文件到此区域开始上传
                        </p>
                      </div>
                    </a-upload-dragger>
                    <div
                      class="edit-wrap"
                      v-if="fileInfo.name"
                      :title="fileInfo.name"
                    >
                      <a-icon type="link" class="edit-left" />
                      <span class="edit-name">{{ fileInfo.name }}</span>
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-item
                    label="版本号"
                    required
                    :labelCol="{ span: 8 }"
                    :wrapperCol="{ span: 11 }"
                  >
                    <a-input
                      placeholder="请填写版本号"
                      class="item-input"
                      v-decorator="[
                        'version',
                        {
                          validateTrigger: 'blur',
                          rules: [{ validator: checkVersionNum }]
                        }
                      ]"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item
                    label="版本包类型"
                    required
                    :labelCol="{ span: 5 }"
                    :wrapperCol="{ span: 11 }"
                  >
                    <a-select
                      placeholder="请选择版本包类型"
                      class="item-input"
                      v-decorator="[
                        'packType',
                        {
                          validateTrigger: 'blur',
                          rules: [
                            { required: true, message: '请选择版本包类型' }
                          ]
                        }
                      ]"
                    >
                      <a-select-option
                        v-for="(i, index) in packTypeSelects"
                        :key="index + i"
                        :value="i"
                        >{{ i }}</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col>
                  <a-form-item
                    label="版本说明"
                    required
                    :labelCol="{ span: 4 }"
                    :wrapperCol="{ span: 16 }"
                  >
                    <a-textarea
                      placeholder="请描述该版本更新内容"
                      class="item-input item-text"
                      :rows="4"
                      :maxLength="140"
                      @change="checkExplainLength"
                      v-decorator="[
                        'remark',
                        {
                          validateTrigger: 'blur',
                          rules: [
                            {
                              required: true,
                              min: 1,
                              message: '请描述该版本更新内容'
                            }
                          ]
                        }
                      ]"
                    />
                    <div class="explain-text">{{ explainLength + "/140" }}</div>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col>
                  <div class="btn-wrap">
                    <a-button
                      type="primary"
                      class="tool-btn"
                      style="margin-right: 32px;"
                      @click="handleSubmit"
                      :loading="btnLoading"
                      >保存</a-button
                    >
                    <a-button
                      class="tool-btn"
                      style="color: #5862CB; background: #ECEDFF;"
                      @click="$router.push('/version/management')"
                      >取消</a-button
                    >
                  </div>
                </a-col>
              </a-row>
            </a-form>
          </a-spin>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import VersionServices from "@/services/version.services";
import uploadService from "@/services/upload.services";
import axios from "axios";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "VersionEC",
  data() {
    return {
      fileList: [],
      file: "",
      formData: this.$form.createForm(this, { name: "versionForm" }),
      routes: [
        {
          name: "版本管理",
          path: "/version/management"
        },
        {
          name: "版本上传",
          path: ""
        }
      ],
      // 设备类型
      deviceTypeSelects: [
        {
          name: "门禁设备",
          code: "Entrance_guard"
        },
        {
          name: "手持设备",
          code: "Handheld_device"
        },
        {
          name: "访客设备",
          code: "Visitor_device"
        },
        {
          name: "支付设备",
          code: "Payment_device"
        },
        {
          name: "节点设备",
          code: "Node_device"
        },
        {
          name: "屏显设备",
          code: "Screen_device"
        },
        {
          name: "门牌设备",
          code: "Screen_device"
        }
      ],
      deviceModelSelects: [], // 设备型号
      packTypeSelects: ["软件包", "固件包"],
      id: "",
      formLoading: false,
      btnLoading: false,
      noUpLoad: false, // 编辑-表单项禁用标杆
      nocheckmodel: true, // 设备型号禁用标杆
      formItemLayout: {
        labelCol: { span: 4, offset: 1 },
        wrapperCol: { span: 15 }
      },
      apkIcon: require("@/assets/head.png"),
      fileInfo: {},
      // 版本说明文字长度
      explainLength: 0
    };
  },
  computed: {
    // 监听属性 类似于data概念
    ...mapGetters("versionmanage", ["uploadVersionlist"])
  },
  watch: {
    // 监控data中的数据变化
  },
  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getVersionDetail(this.id);
    }
    if (this.$route.query.sn && this.$route.query.type) {
      this.getVersionDetail(this.$route.query.sn);
    }
  },
  methods: {
    ...mapMutations("versionmanage", ["ADD_VERSIONLIST"]),

    // 获取设备型号列表
    async getdeviceModelList(type) {
      const { status, result } = await VersionServices.GetEquType({
        type: type
      });

      if (status === 0) {
        this.deviceModelSelects = result;
      }
    },
    async checkasstype(e) {
      if (e) {
        this.nocheckmodel = false;
        await this.getdeviceModelList(e);
        this.formData.setFieldsValue({
          deviceModel: []
        });
      } else {
        this.nocheckmodel = true;
      }
    },
    // 软件版本号校验
    checkVersionNum(rule, value, callback) {
      let reg = /^([v]|[V])([1-9]|([1-9][0-9]))(\.)([0-9]|([1-9][0-9]))(\.)([0-9]|([1-9][0-9]))$/;
      if (value && !reg.test(value)) {
        callback(new Error("版本号格式错误，例:V1.1.1或V11.11.11"));
      } else if (!value) {
        callback(new Error("请填写软件版本号"));
      } else {
        callback();
      }
    },

    // 固件上传验证
    checkFile(rule, value, callback) {
      if (!this.file && !this.id) {
        callback(new Error("请上传版本包"));
      } else {
        callback();
      }
    },

    // 版本说明长度更新
    checkExplainLength(e) {
      this.explainLength = e.target.value.length;
    },

    // "编辑">>版本详情
    async getVersionDetail(data) {
      this.formLoading = true;
      let res = await VersionServices.GetVersionDetail({ id: data });
      this.formLoading = false;
      if (res.status === 0) {
        this.formData.setFieldsValue({
          type: res.result.type,
          deviceModel: res.result.deviceModel,
          version: res.result.version,
          packType: res.result.packType,
          remark: res.result.remark
        });
        this.fileInfo.size = res.result.size;
        this.fileInfo.url = res.result.url;
        if (this.$route.query.sn) {
          this.fileInfo.name = "";
        } else {
          this.fileInfo.name = res.result.name;
        }
        this.explainLength = res.result.remark.length;
        this.noUpLoad = true;
        this.nocheckmodel = true;
        // 测试↓↓↓
        // console.log('"编辑">>版本详情----', this.fileInfo);
      }
    },

    // 上传事件--验证切换的文件
    handleChange({ file, fileList }) {
      fileList = [fileList[fileList.length - 1]];
      let fileVersion = "";
      let filePackType = undefined;
      let newFile = file.name.substr(file.name.indexOf("-v") + 1);
      // console.log(newFile, "newFile", file, "file");
      fileVersion =
        file.name.indexOf("-v") !== -1
          ? newFile.substr(0, newFile.indexOf("-"))
          : "";
      let isSixMini = /\.tar\.gz$/.test(file.name)||/\.tar$/.test(file.name);
      if (isSixMini) {
        if (file.name.includes("debug")) {
          this.notification(
            "error",
            "操作失败",
            "上传失败,请检查版本包是否正确"
          );
          return;
        }
      } else {
        let isAPK =
          file.type === "application/vnd.android.package-archive" ||
          file.name.split(".")[file.name.split(".").length - 1] === "zip";
        let isIMG =
          file.name.split(".")[file.name.split(".").length - 1] === "img";
        // 判断类型apk
        let isType = isAPK || isIMG;
        if (!isType) {
          this.notification(
            "error",
            "操作失败",
            "上传失败,请检查版本包是否正确"
          );
          return;
        }
        if (file.name.includes("debug")) {
          this.notification(
            "error",
            "操作失败",
            "上传失败,请检查版本包是否正确"
          );
          return;
        }
        if (isAPK) {
          filePackType = "软件包";
        }
        if (isIMG) {
          filePackType = "固件包";
        }
      }

      if (fileList[0]) {
        this.fileList = fileList;
        fileList[0].status = "down";
        fileList[0].response = "成功";
        this.file = file;
        this.fileInfo = {};
        this.formData.setFieldsValue({
          version: fileVersion,
          packType: filePackType
        });
      } else {
        this.file = "";
        this.fileList = [];
      }
    },

    // 正式上传
    async fileUpload() {
      let formData = new FormData();
      let type = this.deviceTypeSelects.find(item => {
        return item.name === this.formData.getFieldValue("type");
      }).code;
      let timerait = new Date().getTime();
      let version = this.formData.getFieldValue("version");
      if (type && version) {
      } else {
        this.$message.error("请先选择适用设备并填写版本号");
        return;
      }
      const path = `apk/${type}/${timerait}${version}`;
      formData.append("key", path);
      let eventId = this.getUUid();
      formData.append("eventId", eventId);
      formData.append("file", this.file.originFileObj);

      // console.log(formData, "formData111111111");
      // let res = await uploadService.upload(formData);  //文件上传
      let res = await uploadService.UploadFile(formData); // 版本包上传专业接口
      if (res.status === 0) {
        this.ADD_VERSIONLIST({
          eventId: eventId,
          url: res.result,
          percent: 0,
          isAbnormal: false,
          isComplete: false
          // url: res.result
        });
      }
      return res;
    },

    // 提交
    async handleSubmit(e) {
      e.preventDefault();
      this.formData.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          let data = {};
          this.btnLoading = true;
          // 版本号首字母大写
          let formatVersion = values.version.toUpperCase();
          data.type = values.type;
          data.deviceModel = values.deviceModel;
          data.packType = values.packType;
          data.version = formatVersion;
          data.remark = values.remark;

          if (this.file) {
            data.name = this.file.name.includes(".img")
              ? this.file.name.split(".img")[0]
              : this.file.name.split(".apk")[0];
            let url = await this.fileUpload();
            if (url.status != 0) {
              // this.$notification["error"]({
              //   message: "操作失败",
              //   description: url.errorMsg
              // });
              this.btnLoading = false;
              return;
            }
            data.url = url.result;
            data.size = parseInt(this.file.size / 1024 / 1024);
          } else {
            data.url = this.fileInfo.url;
            data.size = this.fileInfo.size;
            data.name = this.fileInfo.name;
          }

          // console.log("提交====", data);

          let res;
          if (this.id) {
            data.id = this.id;
            res = await VersionServices.EditNewVersion(data);
          } else if (this.$route.query.sn) {
            data.id = this.$route.query.sn;
            res = await VersionServices.EditNewVersion(data);
          } else {
            res = await VersionServices.AddNewVersion(data);
          }
          this.btnLoading = false;
          if (res.status === 0) {
            this.notification("success", "成功", res.result);
            this.$router.push("/version/management");
          }
        }
      });
    },
    getUUid() {
      let value = "xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        let r = (Math.random() * 16) | 0;
        let v = c == "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      });
      return value;
    }
  }
};
</script>
<style lang="less">
.version-ec {
  .anticon-close {
    display: none !important;
  }
  .ant-form-item {
    margin-bottom: 32px !important;
  }
  .ant-upload {
    .ant-upload-drag-container {
      display: block !important;
    }
  }
  .edit-wrap {
    margin-top: 8px;
    line-height: 22px;
    height: 22px;
    position: relative;
    .edit-name {
      display: inline-block;
      margin-left: 24px;
      font-size: 14px;
      max-width: 955px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .edit-left {
      font-size: 12px;
      position: absolute;
      left: 4px;
      top: 6px;
    }
    .edit-right {
      cursor: pointer;
      font-size: 12px;
      position: absolute;
      right: 4px;
      top: 6px;
    }
  }
  .edit-wrap:hover {
    background: #f0f2f5;
  }
}
</style>
<style lang="less" scoped>
// @import url(); 引入公共css类
.version-ec {
  .content-wrap {
    height: 891px;
    margin: 0 16px 16px;
    padding: 24px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    .page-title {
      font-size: 18px;
      color: #5862cb;
      margin-bottom: 140px !important;
    }
    .from-wrap {
      flex: 1;
      .item-input {
      }
      .item-text {
        height: 108px !important;
        position: relative;
      }
      .explain-text {
        position: absolute;
        // color: royalblue;
        font-size: 10px;
        bottom: -15px;
        right: 20px;
      }
      .btn-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        .tool-btn {
          width: 88px;
          height: 32px;
          border-radius: 3px;
        }
      }
    }
  }
  .show-apkName {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
    .apk-icon {
      width: 60px;
      height: 60px;
      margin-bottom: 8px;
    }
  }
}
</style>
